<template>
    <gofix-card fullContent class="mb-0 pt-20">
        <gofix-table
            :settings="tableConfig"
            :table-items="tableItems"
            :column-setting-contract-id="$route.params.id"
            @load-items="getTableData"
            @row-click="moreItem"
            ref="gofixTable">
        </gofix-table>
    </gofix-card>
</template>

<script>
    import { mapGetters } from "vuex";
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';
    export default {
        name: "replacement-history",
        components: { },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['equipment']));
            filter.equipment_status = {"type":"text","value":"Replaced","function":"ilike","with":[]}
            filter.tag_name = {"type":"text","value":"","function":"ilike","with":[]}
            return {
                tableConfig: {
                    name: 'table-replacement-history',
                    controls: {
                        create: false,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                    },
                    filter: filter,
                    buildFilter: false,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "desc",
                    fields: [
                        {
                            key: 'equipment_type',
                            label: 'Equipment Group',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'location_info.name',
                            label: 'Location',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'brand',
                            label: 'Brand',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left'
                        },
                        {
                            key: 'model',
                            label: 'Model',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-right',
                            tdClass: 'text-right'
                        },
                        {
                            key: 'serial_number',
                            label: 'S/N',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-right',
                            tdClass: 'text-right'
                        },
                        {
                            key: 'equipment_status',
                            label: 'Status',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-right',
                            tdClass: 'text-right'
                        },
                        {
                            key: 'auto',
                            label: '',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                    ]
                },
                pages: {
                    isCMS: '1',
                    limit: 100,
                    page: 1,
                    totalPage: 0,
                    filter: JSON.parse(JSON.stringify(filters['equipment']))
                },
                tableItems:[],
                columnSettings: [],
                loading: false
            };
        },
        created() { 
            this.tableConfig.filter.tag_name.value = this.equipment.tag_name ? this.equipment.tag_name : ''
        },
        computed: {
            ...mapGetters({
                equipment: "EquipmentV2Controller/equipment"
            })
        },
        filters: {
            getCustomValue: function (value, key,type) {
                if (value && Array.isArray(value)) {
                    for (var i = 0; i < value.length; i++) {
                        if (value[i].attribute_id === key) {
                            if(type === "DateTime"){
                                if(value[i].value){
                                    return moment(value[i].value, "YYYY-MM-DD").format("DD.MM.YYYY");
                                }
                            }
                            return value[i].value;
                        }
                    }
                } else {
                    return '';
                }
            }
        },
        methods: {
            async getTableData(callback){

                const {tableRequest, resolve, reject} = await callback();

                if (!tableRequest.filter.contract_id.value) {
                    tableRequest.filter.contract_id.value = this.$route.params.id;
                }
                tableRequest.filter.location_id.value = this.pages.filter.location_id.value;
                tableRequest.filter.equipment_group_id.value = this.pages.filter.equipment_group_id.value;

                await this.$store.dispatch("EquipmentV2Controller/getEquipments", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response.data.data);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the equipments", "danger");
                    reject();
                })
            },
            getColumnSettings(settings) {
                this.columnSettings = settings;
            },
            moreItem(item) {
                let routeData = this.$router.resolve(`/v2/contract-client/${this.$route.params.id}/equipment/${item.id}`);
                window.open(routeData.href, '_blank');
            },
        }
    }
</script>
